export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/resources/components.js